import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

const HomeServicesNew: React.FC<{ hlanguage: any,allImagesLink:any }> = ({ hlanguage,allImagesLink }) => {
  // const hlanguage = useSelector((state: any) => state.auth.homeLanguage);
  const navigate = useNavigate();
  const base_Url = process.env.REACT_APP_BASE_URL;
  const [showDocsModal, setShowDocsModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");

  const getImageFromGCATrader = (
    images: any,
    matchName: string
  ) => {
    const found = images?.GCATraderLinkPage?.find((item: any) =>
      item?.fileName?.includes(matchName)
    );
    return found ? `${base_Url}${found?.fileUrl}` : "";
  };

const services = [
  {
    title: hlanguage?.trader_reg,
    desc: hlanguage?.tra_desc,
    img: getImageFromGCATrader(allImagesLink, "imgH1"),
    role: "Trader",
    buttonVal: hlanguage?.register_now,
  },
  {
    title: hlanguage?.panel_reg,
    desc: hlanguage?.panel_desc,
    img: getImageFromGCATrader(allImagesLink, "imgH3"),
    role: "Panel_Engineer",
    buttonVal: hlanguage?.register_now,
  },
  {
    title: hlanguage?.gca_reg,
    desc: hlanguage?.gca_desc,
    img: getImageFromGCATrader(allImagesLink, "imgH2"),
    role: "General_Commission_Agent",
    buttonVal: hlanguage?.register_now,
  },
  {
    title: hlanguage?.scheme_forms,
    desc: hlanguage?.scheme_desc,
    img: getImageFromGCATrader(allImagesLink, "imgH4"),
    role: "Schemes",
    buttonVal: hlanguage?.know_more,
  },
];


  const roleDisplayNames: Record<string, { key: string }> = {
    Trader: { key: "trader" },
    Panel_Engineer: { key: "panel_engineer" },
    General_Commission_Agent: { key: "gca" },
  };

  const documents = [
    {
      titleKey: "doc_identity",
      optionsKey: "doc_identity_options",
    },
    {
      titleKey: "doc_address",
      optionsKey: "doc_address_options",
    },
    {
      titleKey: "doc_dob",
      optionsKey: "doc_dob_options",
    },
  ];

  const handleCardAction = (role: string) => {
    if (role === "Schemes") {
      navigate("/login?role=APMC_Login");
      return;
    }

    document.body.classList.add('modal-open');
    setSelectedRole(role);
    setShowDocsModal(true);
  };

  const handleCloseModal = () => {
    document.body.classList.remove('modal-open');
    setShowDocsModal(false);
  };

  const handleProceedToSSO = () => {
    document.body.classList.remove('modal-open');
    const returnurl = `https://gil.thesaicomputers.com/ssoLogin/${selectedRole}`;
    const accesskey = "b6e01c1d689344ad9b412200fb365cc3";
    const combined = `${returnurl}||${accesskey}`;
    const base64Encoded = btoa(combined);

    window.location.href = `https://gujaratsso.gujarat.gov.in/CitizenSSORegistration/UserForm?redirectUrl=${base64Encoded}`;
  };

  return (
    <>
      <section
        className="home-services-section"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/home/crops-info.png)`,
        }}
      >
        <div className="container position-relative">
          <div className="text-center d-flex flex-column align-items-start text-white mb-5">
            <h2 className="fw-bold display-6 text-white">
              {hlanguage?.directorInfo}
            </h2>
            <p className="mt-3 text-lg-start col-12 col-md-6">
              {hlanguage?.directorParaInfo}
            </p>
          </div>

          <div className="row g-4">
            {services.map((item, index) => (
              <div key={index} className="col-md-6 col-lg-3">
                <div
                  className="service-card h-100"
                  role="button"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleCardAction(item.role)}
                >
                  <img src={item.img} alt={item.title} />
                  <div className="service-content">
                    <h5 className="text-start text-white">{item.title}</h5>
                    <p className="text-start fw-light text-white">{item.desc}</p>
                    <button
                      className="register-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCardAction(item.role);
                      }}
                    >
                      <span>{item.buttonVal}</span>
                      <span className="arrow">&gt;</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Modal */}
      {showDocsModal && (
        <div
          className="modal show docs-modal"
          style={{ display: "block" }}
          onClick={handleCloseModal}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header border-bottom">
                <h5 className="modal-title text-white">
                  {hlanguage?.[roleDisplayNames[selectedRole]?.key]}
                  <div className="small mt-1 opacity-75">
                    {hlanguage?.docs_required_subtitle}
                  </div>
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={handleCloseModal}
                ></button>
              </div>

              <div className="modal-body">
                <div className="alert-note mb-3">
                  <strong>{hlanguage?.note_label}</strong> {hlanguage?.note_text}
                </div>

                <ol className="doc-list">
                  {documents.map((doc, index) => (
                    <li key={index} className="doc-item">
                      <div className="doc-title">
                        {hlanguage?.[doc.titleKey]}
                      </div>
                      <div className="doc-options">
                        {hlanguage?.[doc.optionsKey]}
                      </div>
                    </li>
                  ))}
                </ol>
              </div>

              <div className="modal-footer border-top">
                <button
                  type="button"
                  className="btn btn-outline-light me-3 text-white"
                  onClick={handleCloseModal}
                >
                  {hlanguage?.close_button}
                </button>
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={handleProceedToSSO}
                >
                  {hlanguage?.proceed_button}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>
        {`
          .home-services-section {
            position: relative;
            background-size: cover;
            background-position: center;
            padding: 80px 0;
          }

          .service-card {
            background: rgba(15, 55, 20, 0.68);
            backdrop-filter: blur(2px);
            -webkit-backdrop-filter: blur(2px);
            border-radius: 16px;
            overflow: hidden;
            color: #ffffff;
            display: flex;
            flex-direction: column;
            transition: transform 0.3s ease;
          }

          .service-card:hover {
          }

          .service-card img {
            width: 100%;
            height: 180px;
            object-fit: cover;
            transition: transform 0.4s ease;
          }

          .service-card:hover img {
            transform: scale(1.08);
          }

          .service-content {
            padding: 1.25rem;
            text-align: left;
            position: relative;
            display: flex;
            flex-direction: column;
            flex: 1;
          }

          .register-btn {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            background: #1f7a1f;
            color: #fff;
            border-radius: 999px;
            padding: 6px 14px;
            font-size: 0.8rem;
            font-weight: 500;
            border: none;
            transition: all 0.3s ease;
            margin-top: auto;
            align-self: flex-start;
          }

          .register-btn .arrow {
            display: none;
            transform: translateX(-4px);
            transition: all 0.3s ease;
          }

          .service-card:hover .register-btn {
            background: #145c14;
            padding-right: 18px;
          }

          .service-card:hover .register-btn .arrow {
            display: inline-block;
            transform: translateX(0);
          }

          .service-content h5 {
            font-weight: 600;
            margin-bottom: 0.4rem;
            color: #ffffff;
          }

          .service-content p {
            font-size: 0.9rem;
            opacity: 0.9;
            margin-bottom: 1rem;
            color: #eaf5ea;
          }

          /* Modal Styles */
          .docs-modal {
            background: rgba(0, 0, 0, 0.75);
            overflow-y: auto;
            box-shadow: none;
          }

          .docs-modal .modal-dialog {
            max-width: 600px;
            box-shadow: none; 
          }

          .docs-modal .modal-content {
            background: linear-gradient( #006b1d, #004e15);
            border-radius: 12px;
            color: #fff;
            box-shadow: none; 
          }

          .docs-modal .modal-header {
            padding: 1.25rem;
          }

          .docs-modal .modal-body {
            padding: 1.25rem;
          }

          .docs-modal .modal-footer {
            border-color: rgba(255, 255, 255, 0.1);
            padding: 1rem 1.25rem;
          }

          .alert-note {
            border-radius: 8px;
            padding: 0.875rem;
            font-size: 0.9rem;
          }

          .doc-list {
            list-style: none;
            counter-reset: doc-counter;
            padding: 0;
            margin: 0;
          }

          .doc-item {
            counter-increment: doc-counter;
            background: rgba(0, 0, 0, 0.2);
            border: 1px solid rgba(255, 255, 255, 0.15);
            border-radius: 8px;
            padding: 1rem;
            margin-bottom: 0.75rem;
            position: relative;
            padding-left: 3rem;
          }

          .doc-item::before {
            content: counter(doc-counter);
            position: absolute;
            left: 1rem;
            top: 1rem;
            background: rgba(255, 255, 255, 0.2);
            color: #fff;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: 0.9rem;
          }

          .doc-title {
            font-weight: 600;
            margin-bottom: 0.5rem;
            font-size: 0.95rem;
          }

          .doc-options {
            font-size: 0.875rem;
            line-height: 1.5;
          }

          .btn-outline-light {
            border-color: rgba(255, 255, 255, 0.3);
          }

          .btn-outline-light:hover {
            background: rgba(255, 255, 255, 0.1);
            border-color: rgba(255, 255, 255, 0.5);
          }

          body.modal-open {
            overflow: hidden;
          }

          @media (max-width: 768px) {
            .home-services-section {
              padding: 60px 0;
            }

            .service-card {
              backdrop-filter: none;
              -webkit-backdrop-filter: none;
            }

            .docs-modal .modal-dialog {
              margin: 0.5rem;
            }
          }
        `}
      </style>
    </>
  );
};

export default HomeServicesNew;